import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createGift } from '../../../common/api';
import { toast } from 'react-toastify';
import { formatDate } from '../../../common/utils';

import '../modals.css';

const AddGift = ( { close, aid, uid, pReason, obj, objType } ) => {
    const [ desc, setDesc ] = useState( '' );
    const [ reason, setReason ] = useState( '' );
    const [ giftDate, setGiftDate ] = useState( '' );
    const [ price, setPrice ] = useState( '' );
    const [ details, setDetails ] = useState( '' );
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    useEffect( () => {
        if ( desc && desc.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ desc ] );

    useEffect( () => {
        const today = new Date();
        setGiftDate( formatDate( today ) );
        setReason( pReason.find( p => p.default ).value );
    }, [ pReason ] );

    const create = async () => {
        setProcessing( true );
        let cid;

        if ( objType === 'contact' ) {
            cid = obj.details.cid;
        } else if ( objType === 'loan' ) {
            const c = obj.borrowers?.find( f => f.label === 'Primary' );
            if ( c ) {
                cid = c.cid;
            }
        } else {
            console.log( 'Unknown objType - cannot determine cid for creating new gift' );
            alert( 'Unable to determine contact to assign gift to - giving up!' );
            close();
            return;
        }

        const added = await createGift( aid, uid, desc, reason, giftDate, price, details, [ cid ] );
        if ( added.length ) {
            toast.success( `The Gift has been added`, { theme: 'dark' } );
            setProcessing( false );
            close();
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Record a Client Gift</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Date of this gift</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="date" value={giftDate} onChange={ ( e ) => setGiftDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Description of the gift</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a description" value={desc} onChange={ ( e ) => setDesc( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Price of the Gift</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Amount you paid..." value={price} onChange={ ( e ) => setPrice( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Reason for the Gift</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={reason} onChange={ ( e ) => setReason( e.target.value ) }>
                                            {
                                                pReason.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Details of the Gift</Form.Label>
                                        <Form.Control className='tf-modal-text-input' as="textarea" rows={3} placeholder="Details..." value={details} onChange={ ( e ) => setDetails( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    pReason: state.user.meta.gift.picklist.reason
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddGift );